"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_TYPES_WITHOUT_WEBCHAT_UPSELL = exports.PAGETYPES_WITH_SIDEBAR = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
exports.PAGETYPES_WITH_SIDEBAR = [
    web_blizzard_reporting_1.PageType.PRIVATE_USER_PROFILE,
    web_blizzard_reporting_1.PageType.PUBLIC_USER_PROFILE,
    web_blizzard_reporting_1.PageType.SPOTLIGHT,
    web_blizzard_reporting_1.PageType.SEARCH,
    web_blizzard_reporting_1.PageType.LENS_HOME_PAGE,
    web_blizzard_reporting_1.PageType.LENS_PROFILE,
    web_blizzard_reporting_1.PageType.DISCOVER_HOME_PAGE,
    web_blizzard_reporting_1.PageType.MEDIA_SHARE,
    web_blizzard_reporting_1.PageType.VOTE,
    web_blizzard_reporting_1.PageType.BETA,
    web_blizzard_reporting_1.PageType.SNAPCHAT_PLUS_LANDING_PAGE,
    web_blizzard_reporting_1.PageType.JOIN_COMMUNITY,
    web_blizzard_reporting_1.PageType.COOKIE_SETTINGS,
    web_blizzard_reporting_1.PageType.GROUP_INVITE,
    web_blizzard_reporting_1.PageType.ERROR,
    web_blizzard_reporting_1.PageType.NOT_FOUND,
    web_blizzard_reporting_1.PageType.NOT_AVAILABLE,
    web_blizzard_reporting_1.PageType.PREMIUM_PROFILE,
    web_blizzard_reporting_1.PageType.PREMIUM_STORY,
];
exports.PAGE_TYPES_WITHOUT_WEBCHAT_UPSELL = [
    web_blizzard_reporting_1.PageType.SNAPCHAT_HOME_PAGE,
    web_blizzard_reporting_1.PageType.DOWNLOAD_PAGE,
    web_blizzard_reporting_1.PageType.VOTE,
    web_blizzard_reporting_1.PageType.JOIN_COMMUNITY,
    web_blizzard_reporting_1.PageType.GROUP_INVITE,
    web_blizzard_reporting_1.PageType.WEB_ACCOUNTS,
    web_blizzard_reporting_1.PageType.MY_SUBSCRIPTION,
    web_blizzard_reporting_1.PageType.SC_PLUS_SUCCESS,
    web_blizzard_reporting_1.PageType.GIFT_CARD_REDEMPTION,
    web_blizzard_reporting_1.PageType.SESSION_MANAGEMENT,
    web_blizzard_reporting_1.PageType.DOWNLOAD_MY_DATA,
];
//# sourceMappingURL=constants.js.map